import React ,{useState} from "react";
import {Row,Col, Button,Modal} from "react-bootstrap";
import { Card } from 'antd';
import download from "../assets/download.jpg";
import classes from "../CSS/helping.module.css";
import covid1 from "../assets/covid1.jpg";
import Aos from "aos";
import "aos/dist/aos.css";
import villagekids from "../assets/villagekids.jpg";
import career from "../assets/career.jpg";
import pay1 from "../assets/pay1.jpg";

const { Meta } = Card;

const HelpingHand = ()=>{
    Aos.init({duration:1000})
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);
    const handleClose2 = () => setShow2(false);
    const handleShow2= () => setShow2(true);
    const handleClose3 = () => setShow3(false);
    const handleShow3= () => setShow3(true);
    return(
        <>
        <div  style={{backgroundColor:"#EBEBEB",backgroundSize:"100% 100%",paddingTop:"40px"}}>
            <div className="container" style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",
                }}>
                    <center><h2 data-aos="fade-up" style={{fontWeight:"bold",borderBottom:"2px solid #efb1ff",paddingBottom:"20px"}}>S(HE)- You can not take one out of the other.</h2></center><br/>
                    <center><p data-aos="fade-up" style={{fontSize:"18px", fontWeight:"500"}}>What we stand for</p></center>
            </div><br/><br/>
            <div className="container">
                 <Row>
                     <Col style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",
                }} md={4} sm={6} xs={12}>
                     <Card
                        hoverable
                        style={{marginBottom:30}}
                        className={classes.Card}
                        cover={<img className={classes.Img} alt="example" src={villagekids} />}
                    >
                        <Meta title="Gender Equality" description=
                        {
                        <div>
                            <p> We stand head to head against ...</p>
                            <Button onClick={handleShow1} variant="outline-primary">Read More</Button>
                            <Modal show={show1} onHide={handleClose1}>
                                <Modal.Header closeButton>
                                <Modal.Title>Gender Equality</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>We stand head to head against any form of Gender Inequality. The very idea that men and women are NOT equal is sickening. This is eating away our society each day.</Modal.Body>
                                <Modal.Footer>
                                <center><p style={{color:"blue",
                            cursor:"pointer"}} onClick={handleClose1}>Close</p></center>
                                
                                </Modal.Footer>
                            </Modal>

                        </div>
                        }
                        />
                        
                    </Card>
                     </Col>
                     <Col style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",
                }} md={4} sm={6} xs={12}>
                     <Card
                        hoverable
                        style={{marginBottom:30}}
                        className={classes.Card}
                        cover={<img className={classes.Img} alt="example" src={career} />}
                    >
                        <Meta title="Career Choices" description={<div>
                            <p>One of the many forms of this inequality...</p>
                            <Button onClick={handleShow2} variant="outline-primary">Read More</Button>
                            <Modal show={show2} onHide={handleClose2}>
                                <Modal.Header closeButton>
                                <Modal.Title>Career Choices</Modal.Title>
                                </Modal.Header>
                                <Modal.Body> One of the many forms of this inequality is the persistence of Gendered paths in career choices. Studies have repeatedly reported that math and science are perceived as male domains, and scientists as predominantly male. </Modal.Body>
                                <Modal.Footer>
                                <center><p style={{color:"blue",
                            cursor:"pointer"}} onClick={handleClose2}>Close</p></center>
                                
                                </Modal.Footer>
                            </Modal>
                        </div>
                        }
                        />
                        
                    </Card>
                     </Col>
                     <Col style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",
                }} md={4} sm={6} xs={12}>
                     <Card
                        hoverable
                        style={{marginBottom:30}}
                        className={classes.Card}
                        cover={<img className={classes.Img} alt="example" src={pay1}/>}
                    >
                        <Meta title="Equal Pay, Equal Work" description={<div>
                            <p>Fact: Women are paid 79 cents on....</p>
                            <Button onClick={handleShow3} variant="outline-primary">Read More</Button>
                            <Modal show={show3} onHide={handleClose3}>
                                <Modal.Header closeButton>
                                <Modal.Title>Equal Pay, Equal Work</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>Fact: women are paid 79 cents on each dollar a man earns for the same job. We believe in Gender Neutral jobs and equal pay for equal work. We believe in equal participation of every gender in STEM and other fields.</Modal.Body>
                                <Modal.Footer>
                                <center><p style={{color:"blue",
                            cursor:"pointer"}} onClick={handleClose3}>Close</p></center>
                                
                                </Modal.Footer>
                            </Modal>
                        </div>
                        }
                        />
                        
                    </Card>
                     </Col>
                 </Row>
            </div>
            <br/><br/>
        </div>

        </>
    )
}
export default HelpingHand;